import gql from 'graphql-tag'
import * as Fragments from './fragments'
import { CommGetMeQuery, CommGetRememberedAdminUserQuery } from '../../types/CommGetMeQuery'
import { CommGetUsedStorageQuery } from '../../types/CommGetUsedStorageQuery'

export const COMM_GET_ME_Q = gql<CommGetMeQuery>`
  query CommGetMeQuery {
    me {
      ...CommUserInfoFragment
    }
  }
  ${Fragments.COMM_USER_INFO_F}
`

export const COMM_GET_REMEMBERED_ADMIN_USER_Q = gql<CommGetRememberedAdminUserQuery>`
  query CommGetRememberedAdminUserQuery {
    rememberedAdminUser {
      ...CommUserInfoFragment
    }
  }
  ${Fragments.COMM_USER_INFO_F}
`

export const COMM_GET_USED_STORAGE_Q = gql<CommGetUsedStorageQuery>`
  query CommGetUsedStorageQuery {
    usedStorageCurrentUser
  }
`

export const GET_STOCKS_SYMBOLS = gql`
  query GetStocksSymbols {
    getStocksSymbols
  }
`
